import { memo, Ref, useImperativeHandle, useState } from 'react';
import clsx from 'clsx';
import { HiOutlineViewColumns } from 'react-icons/hi2';
import { IDataTableChooserOptions } from '../DataTable.types';
import DataTableColumnChooser, { type IDataTableChooserColumn } from './DataTableColumnChooser';

export interface IDataTableChooserHandle {
    /** Открыть выбор колонок (меню колонки, «Все столбцы скрыты») */
    open: () => void;
}

interface IDataTableChooserControlProps {
    ref: Ref<IDataTableChooserHandle>;
    columns: IDataTableChooserColumn[];
    onApply: (updates: Record<string, boolean>) => void;
    options?: IDataTableChooserOptions;
    /** Подпись кнопки рядом со значком */
    label?: string;
    /** Среди скрытых колонок есть незаполненные обязательные */
    alert?: boolean;
}

/** Кнопка «Колонки» туллбара со своим состоянием: открытие выбора колонок не перерисовывает таблицу. */
const DataTableChooserControl = ({ ref, columns, onApply, options, label, alert }: IDataTableChooserControlProps) => {
    const [opened, setOpened] = useState(false);
    useImperativeHandle(ref, () => ({ open: () => setOpened(true) }), []);
    return (
        <DataTableColumnChooser
            opened={opened}
            onClose={() => setOpened(false)}
            options={options}
            columns={columns}
            onApply={onApply}
            target={
                <button
                    type="button"
                    className={clsx(
                        'dtb__icon-btn',
                        label && 'dtb__icon-btn--label',
                        opened && 'is-active',
                        alert && 'dtb__icon-btn--alert',
                    )}
                    title={alert ? 'Колонки — среди скрытых есть незаполненные обязательные' : 'Колонки'}
                    onClick={() => setOpened((v) => !v)}
                >
                    <HiOutlineViewColumns aria-hidden />
                    {label}
                    {alert && <span className="dtb__icon-btn-dot" aria-hidden />}
                </button>
            }
        />
    );
};

export default memo(DataTableChooserControl);
